import { ReactNode } from 'react';

import { DatetimeShow } from '@fhs/ui';

import {
  hotOnesEndDate,
  hotOnesStartDate,
  tripleStackUSEndDate,
  tripleStackUSStartDate,
} from '../constants';

export type LtoContentUSProps = {
  default?: ReactNode;
  hotOnes: ReactNode;
  ltoContent: ReactNode;
};

export const LtoContentUS = ({
  ltoContent,
  default: defaultContent,
  hotOnes,
}: LtoContentUSProps) => {
  return (
    <DatetimeShow
      after={tripleStackUSStartDate}
      before={tripleStackUSEndDate}
      default={
        <DatetimeShow after={hotOnesStartDate} before={hotOnesEndDate} default={defaultContent}>
          {hotOnes}
        </DatetimeShow>
      }
    >
      {ltoContent}
    </DatetimeShow>
  );
};
